/**
 * Returns the base URl for fuse service endpoints.
 *
 * In PROD (non-local) environments this will be an empty string so that endpoint URLs are relative to
 * the app URL. In local environments, this will always be the dev environment app URL.
 */
export function fuseBaseServiceUrl(): string {
  return "";
}

/**
 * Given a set of key/value strings, builds and properly encodes a query string
 * @param params key/value strings
 * @return a query strong; does not include '?'
 */
export function buildQueryString(params: Record<string, string>): string {
  const searchParams = new URLSearchParams();
  for (const key in params) {
    searchParams.append(key, params[key]);
  }
  return searchParams.toString();
}
